/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiMessageBase } from './AaiMessageBase';
import { IAaiTrait } from './IAaiTrait';
import { AaiTraitType } from './AaiTraitType';
import { AaiTag } from './AaiTag';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiMessageBase
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiMessageTrait extends AaiMessageBase implements IAaiTrait {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.IAaiTrait#getTraitType()
     * @return {AaiTraitType}
     */
    public getTraitType() : AaiTraitType {
        return AaiTraitType.message;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitMessageTrait(this);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiMessageBase#addTag(io.apicurio.datamodels.asyncapi.models.AaiTag)
     * @param {AaiTag} tag
     */
    public addTag(tag : AaiTag) {
        if(this.tags == null) this.tags = <any>([]);
        /* add */(this.tags.push(tag)>0);
    }
}
AaiMessageTrait["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiMessageTrait";
AaiMessageTrait["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.asyncapi.models.IAaiTrait","io.apicurio.datamodels.core.models.common.INamed"];




